module.exports = __webpack_public_path__ + "static/img/pelvic-img-left.0a0a6ce3.gif";